import React from 'react';
import * as msgpub from "msgpub";
import { TokenInput, Heading, ButtonG } from '../Common';
import { DisablesContext } from '../../constant/UserMqtt';
import { Box, Grid } from 'grommet';
import { HeaderStyleForGrommet, MainStyleForGrommet } from '../../constant/Styles';
import { status_mapper } from '../../common/common';

export default function TokenUpdate(props: {user?: msgpub.User, setLog: any, setToken: any}) {
    const {user, setLog, setToken} = props;
    const [token, setTokenForThisNode] = React.useState("");
    const disables = React.useContext(DisablesContext);

    const update = () => {
        user?.updateToken({
            token: token,
            callback: (status) => {
                setLog((prevLog: string) => (prevLog + "status: " + status_mapper(status) + "\n"));
                if (status === msgpub.Status.SUCCESS) {
                    setToken(token);
                }
            }
        });
    };

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTokenForThisNode(event.target.value);
    }

    return (
        <div>
            <Grid
                rows={['auto', 'auto']}
                columns={['auto', 'auto']}
                gap="xsmall"
                areas={[
                    { name: 'header', start: [0, 0], end: [1, 0] },
                    { name: 'main', start: [0, 1], end: [1, 1] },
                ]}
            >
                <Box {...HeaderStyleForGrommet}>
                    <Heading title="update token"/>
                </Box>
                <Box {...MainStyleForGrommet}>
                    <form>
                        <TokenInput placeholder="token" value={token} onChange={onChange} disabled={disables.tokenForUpdate}/>
                        <ButtonG name="update" callback={update} disabled={disables.tokenForUpdate}/>
                    </form>
                </Box>
            </Grid>
        </div>
    );
}
